import Generator from '../../../Generator'
import Types from '../../../../actions/Types'

export default Generator.node({
  baseType: Types.EXECUTIONS,
  nodeType: Generator.NODETYPE.DELETE
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/executions/delete.js